// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import redirectToSignInSessionTimeout from "@ces/App/Handlers/XNG/RedirectToSignInSessionTimeout";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateShipTo as updateShipToApi } from "@insite/client-framework/Services/CustomersService";
import {
    SendDataToApi,
    chain as UpdateShipToChain,
} from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";

import translate from "@insite/client-framework/Translate";

export const XngSendDataToApi: typeof SendDataToApi = async props => {
    try {
        props.apiResult = await updateShipToApi(props.apiParameter);
    } catch (error) {
        // XNG-Change
        (props.parameter as any).onError?.(
            error.status === 400 ? error.errorJson.message : translate("There is an error please contact support team"),
        );

        props.dispatch(redirectToSignInSessionTimeout({ errorMessage: error.errorJson.message }));

        return false;
    }
};

replaceInChain(UpdateShipToChain, SendDataToApi, XngSendDataToApi);
